//TODO: This module will be depecrated; 
import Cookies from 'universal-cookie';
import format from 'format-util';
import {SYS_ERROR_DICTIONARY_IDS, APP_ERROR_DICTIONARY_IDS, WARNING_DICTIONARY_IDS, SUCCESS_DICTIONARY_IDS, ALL_DICTIONARY_IDS, BASE_MESSAGE_DICTIONARY, TYPES as _MESSAGE_TYPES} from './inAppMessagesDictionaryClient';
import { TOAST_ACTION_TYPES } from '../components/inAppMessages/toastActions';
import process from 'process'

const cookies = new Cookies();
const disableLogging = !cookies.get('enableLogging');
const levels = ['none', 'message', 'warn', 'info', 'log', 'debug', 'trace'];

let defaultLogLevelIdx = levels.indexOf('debug');

export const SYS_ERRORS = SYS_ERROR_DICTIONARY_IDS;
export const ERRORS = APP_ERROR_DICTIONARY_IDS;
export const WARNING_MESSAGES = WARNING_DICTIONARY_IDS;
export const SUCCESS_MESSAGES = SUCCESS_DICTIONARY_IDS;
export const ALL_MESSAGES = ALL_DICTIONARY_IDS;

export const MESSAGE_TYPES = _MESSAGE_TYPES;

export const LOG_LEVELS = {};
levels.forEach(function(level) {
  LOG_LEVELS[level.toUpperCase()] = level;
  LOG_LEVELS[level.toLowerCase()] = level;
});

export const LOGGER_ACTIONS = {
  SET_DICTIONARY_ERROR: 'LOGGER.IN_APP.SET_DICTIONARY_ERROR',
  CLEAR_DICTIONARY_ERROR: 'LOGGER.IN_APP.CLEAR_DICTIONARY_ERROR',
  CLEAR_ALL_DICTIONARY_ERRORS: 'LOGGER.IN_APP.CLEAR_ALL_DICTIONARY_ERRORS',
  MESSAGE_DICTIONARY_RELOADED: 'LOGGER.MESSAGE_DICTIONARY_RELOADED',
  SET_SUCCESS_MESSAGE: 'LOGGER.SET_SUCCESS_MESSAGE',
  CLEAR_SUCCESS_MESSAGE: 'LOGGER.CLEAR_SUCCESS_MESSAGE'
};

export class inAppMessage extends Error {
  constructor(messageId) {
    super('inAppMessage: '+messageId);
    this.inAppMessageId = messageId;
  }
}


let dispatch = function () {
  if(process.env.NODE_ENV !== 'test') {
    console.error('[LOGGER].dispatch: not initialised! called with: ', arguments);
  }
};

let MESSAGE_DICTIONARY = BASE_MESSAGE_DICTIONARY;

// TODO: Do this as a polyfill when I figure out how to get webpack to like it.
function deepClone(data) {
  if (data === null || typeof data !== 'object') {
    return data;
  }
  if(data instanceof Date){
    return new Date(data.getTime());
  }
  if (Array.isArray(data)) {
    return data.map((entry) => {return deepClone(entry)});
  }
  let clone = new data.constructor();
  for (var prop in data) {
    if (data.hasOwnProperty(prop)) {
      clone[prop] = deepClone(data[prop])
    }
  }
  return clone;
}

// const log = new Logger('LOGGER', LOG_LEVELS.DEBUG);

function scopeAndErrorFilterFactory(scope, message, invert)  {
  return (entry) => {
    const found = entry.scope === scope && entry.message && typeof message === 'object' && entry.message.id === message.id;
    return  invert ? !found : found;
  }
}

export const updateSubStateFromAction = (state = {}, action) => {
  // console.log('[LOGGER]-updateSubStateFromAction(): ', action);

  const getNewState = (action, state) => {

    function addError(actionType, scope, message, args) {
      // console.log('[LOGGER]-updateSubStateFromAction.addError:', actionType, scope, message, args);
      if (!message || !message.behaviour) {
        return state;
      }

      const timeout = message.behaviour.timeout;

      if (!state.inAppMessages) {
        state.inAppMessages = [];
      }

      if (!state.inAppToasts) {
        state.inAppToasts = [];
      }

      let entry = state.inAppMessages.find(scopeAndErrorFilterFactory(scope, message));
      if (!entry) {
        entry = {message, args, scope};
        state.inAppMessages.push(entry);
      }

      if (!entry.clear) {
        const clearAction = {type: LOGGER_ACTIONS.CLEAR_DICTIONARY_ERROR, scope, message};
        // console.log('[LOGGER]-updateSubStateFromAction.addError: clearAction:', actionType, entry, clearAction);
        entry.clear = function() {
          // console.log('[LOGGER]-updateSubStateFromAction.addError.clear(): ', actionType, entry);
          dispatch(clearAction);
        }
      }
      if (typeof entry.clearTimeout != 'undefined') {
        // console.log('[LOGGER]-updateSubStateFromAction.addError: stopping clearTimeout', actionType, entry);
        clearTimeout(entry.clearTimeout);
        delete entry.clearTimeout;
      }
      if (timeout >= 0) {
        // console.log('[LOGGER]-updateSubStateFromAction.addError: setting clearTimeout', actionType, entry);
        entry.clearTimeout = setTimeout(entry.clear, timeout);
      }
      else {
        // console.log('[LOGGER]-updateSubStateFromAction.addError: no timeout to set', actionType, entry);
      }

      // console.log('[LOGGER]-updateSubStateFromAction.addError: returning state:', action, entry, state);
      return state;
    }

    function removeAllErrors(scope) {
      state.inAppMessages = [];
      return state;
    }

    function removeError(actionType, scope, message) {
      if (!message || !message.behaviour) {
        return state;
      }

      if (!state.inAppMessages) {
        state.inAppMessages = [];
      }
      let entry = state.inAppMessages.find(scopeAndErrorFilterFactory(scope, message));
      if (entry) {
        if (entry.clearTimeout != undefined) {
          // console.log('[LOGGER]-updateSubStateFromAction.removeError: stopping clearTimeout', action, entry);
          clearTimeout(entry.clearTimeout);
          delete entry.clearTimeout;
        }
        state.inAppMessages = state.inAppMessages.filter(scopeAndErrorFilterFactory(scope, message, true));
      }
      return state;
    }

    function getToastsArray(currentState) {
      return currentState.inAppToasts || [];
    }

    switch (action.type) {
      case LOGGER_ACTIONS.SET_DICTIONARY_ERROR:
        return addError(action.type, action.scope,  action.message, action.args);
      case LOGGER_ACTIONS.CLEAR_DICTIONARY_ERROR:
        return removeError(action.type, action.scope,  action.message);
      case LOGGER_ACTIONS.CLEAR_ALL_DICTIONARY_ERRORS:
        return removeAllErrors(action.scope);
      case LOGGER_ACTIONS.MESSAGE_DICTIONARY_RELOADED:
        return Object.assign({}, state, {errorDictionary: action.errorDictionary});
      
      // Toast actions
      case TOAST_ACTION_TYPES.ADD_TOAST:
        return {
          ...state,
          inAppToasts: [...getToastsArray(state), action.payload]
        };
      
      case TOAST_ACTION_TYPES.REMOVE_TOAST:
        return {
          ...state,
          inAppToasts: getToastsArray(state).filter(toast => toast.id !== action.payload.id)
        };
      
      case TOAST_ACTION_TYPES.CLEAR_TOASTS:
        return {
          ...state,
          inAppToasts: action.payload.scope
            ? getToastsArray(state).filter(toast => toast.scope !== action.payload.scope)
            : []
        };
        
      default:
        return state;
    }
  };
  return getNewState(action, deepClone(state));
};

export default class Logger {
  static setDispatcher(dispatcher) {
    dispatch = dispatcher;
  }
  static updateErrorDictionary(dictionary) {
    MESSAGE_DICTIONARY = dictionary;
    dispatch({type: LOGGER_ACTIONS.MESSAGE_DICTIONARY_RELOADED, errorDictionary: dictionary})
  }
  constructor(scope, startingLevel) {
    startingLevel = startingLevel || levels[defaultLogLevelIdx];
    this.setLevel(startingLevel);
    const self = this;
    
    levels.forEach(function(level, idx) {
      self[level] = function() {
        if (disableLogging ||  this.logLevel < idx ) {
          return;
        }
        const args = [].slice.call(arguments);
        if (args[0]) {
          args[0] = format('[%s]-[%s]: ', level.toUpperCase(), scope, args[0]);
        }
        console.log.apply(console, args);
      }
    });

    this.setDictionaryMessage = function() {
      const args = [].slice.call(arguments);
      let messageId = args.shift();
      // console.log('[LOGGER]-setDictionaryMessage:', messageId);

      const messageEntry = MESSAGE_DICTIONARY[messageId] || MESSAGE_DICTIONARY[0];

      dispatch({type: LOGGER_ACTIONS.SET_DICTIONARY_ERROR, scope, message: messageEntry,  args: messageEntry.id === messageId ? args : [messageId]})

    };
    this.setSuccessMessage = function(languageString) {
      // const args = [].slice.call(arguments);
      // let messageId = args.shift();
      // console.log('[LOGGER]-setDictionaryMessage:', messageId);

      dispatch({type: LOGGER_ACTIONS.SET_SUCCESS_MESSAGE, scope, successMessage: languageString})

    };
    this.clearSuccessMessage = function(languageString) {
      // const args = [].slice.call(arguments);
      // let messageId = args.shift();
      // console.log('[LOGGER]-setDictionaryMessage:', messageId);

      dispatch({type: LOGGER_ACTIONS.CLEAR_SUCCESS_MESSAGE, scope, successMessage: languageString})

    };
    this.clearDictionaryError = function() {
      let args = [].slice.call(arguments);
      let messageId = args.shift();
      const messageEntry = MESSAGE_DICTIONARY[messageId] || MESSAGE_DICTIONARY[0];
      dispatch({type: LOGGER_ACTIONS.CLEAR_DICTIONARY_ERROR, scope, message: messageEntry,  args: messageEntry.id === messageId ? args : [messageId]})
    };
    this.clearAllDictionaryErrors = function() {
      dispatch({type: LOGGER_ACTIONS.CLEAR_ALL_DICTIONARY_ERRORS, scope})
    }
  }
  setLevel(level) {
    const levelIndex = levels.indexOf(level.toLowerCase());
    this.logLevel = levelIndex < 0 ? 0 : levelIndex;
  }
}
